import {prependRoot} from "../util/prependRoot.js";
import {getApiRoot} from "../store/configureStore.js";
import Axios from "axios";
let apiRoot;

const routePrefix = "/referentie/";

const ReferentieApi = {
	getAll() {
		const serviceUrl = prependRoot(routePrefix + 'getall', getApiRoot());
		return Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default ReferentieApi;
